import React from 'react';

function WhoWeAreSection({ setView }) {
  const handleNav = (e, path, view) => {
    e.preventDefault();
    if (setView) {
      if (window.location.pathname !== path) {
        window.history.pushState({}, '', path);
      }
      setView(view);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = path;
    }
  };

  return (
    <section className="who-we-are-section">
      <div className="container who-we-are-container">
        
        {/* Left Column: Vertical Image with Curved Corners */}
        <div className="who-we-are-left">
          <div className="who-we-are-img-wrapper">
            <img 
              src="/assets/images/service_approach_professional.png" 
              alt="Team member at work" 
              className="who-we-are-img"
            />
          </div>
        </div>

        {/* Right Column: Content */}
        <div className="who-we-are-right">
          
          {/* Subtitle Label */}
          <div className="who-we-are-badge-row">
            <span className="who-we-are-badge">Who We Are</span>
            <span className="who-we-are-badge-line"></span>
          </div>

          <h2 className="who-we-are-title">
            Leading Business Excellence Since 2016
          </h2>

          <p className="who-we-are-subtext">
            We deliver professional business solutions that drive growth and success for companies across Pakistan.
          </p>

          <p className="who-we-are-description">
            Since 2016, Experts Communication has been your leading{' '}
            <a
              href="/bpo-services/"
              onClick={(e) => handleNav(e, '/bpo-services/', 'bpo-services')}
              className="red-link"
            >
              BPO company
            </a>{' '}
            that provides complete business process outsourcing,{' '}
            <a
              href="/it-services/"
              onClick={(e) => handleNav(e, '/it-services/', 'it-services')}
              className="red-link"
            >
              IT services
            </a>
            ,{' '}
            <a
              href="/digital-marketing/"
              onClick={(e) => handleNav(e, '/digital-marketing/', 'digital-marketing')}
              className="red-link"
            >
              digital marketing
            </a>
            , and{' '}
            <a
              href="/web-development/"
              onClick={(e) => handleNav(e, '/web-development/', 'web-development')}
              className="red-link"
            >
              custom web development
            </a>
            . We built our reputation and delivered the best results for clients across the country. Our team combines technical skills with proper industry knowledge to present solutions that truly make a difference.
          </p>

          {/* 2 Feature Cards Row */}
          <div className="who-we-are-features">
            
            {/* Card 1 */}
            <div className="who-feature-card">
              <div className="who-feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
                  <path d="M9 22v-4h6v4" />
                  <path d="M8 6h.01" />
                  <path d="M16 6h.01" />
                  <path d="M12 6h.01" />
                  <path d="M12 10h.01" />
                  <path d="M12 14h.01" />
                  <path d="M16 10h.01" />
                  <path d="M16 14h.01" />
                  <path d="M8 10h.01" />
                  <path d="M8 14h.01" />
                </svg>
              </div>
              <h4 className="who-feature-title">9+ Years of Excellence</h4>
              <p className="who-feature-desc">
                Nearly a decade of consistent service delivery and client satisfaction across Pakistan.
              </p>
            </div>

            {/* Card 2 */}
            <div className="who-feature-card">
              <div className="who-feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </div>
              <h4 className="who-feature-title">Customer Support</h4>
              <p className="who-feature-desc">
                Round-the-clock customer support to maintain smooth operations for your business.
              </p>
            </div>

          </div>

          {/* Bottom Callout & Button */}
          <div className="who-we-are-bottom">
            <div className="who-callout-border">
              <span className="who-callout-text">Discover Our Full Range of Business Solutions</span>
            </div>
            
            <a
              href="/services/"
              onClick={(e) => handleNav(e, '/services/', 'services')}
              className="btn-who-services"
            >
              Our Services →
            </a>
          </div>

        </div>

      </div>
    </section>
  );
}

export default WhoWeAreSection;
